//TODO(pj): Adicionar eventos para todas as acoes realizadas em um InputDocument.
export default {
	ATTACH_DOCUMENT_MODAL_OPEN: 'ATTACH_DOCUMENT_MODAL_OPEN'
};
